/**
 * Converts an array to a comma-separated string
 * @param array - Array of strings to join
 * @returns Comma-separated string or empty string if array is empty
 */
import { numToPaddedString } from "./formatting"

function arrayToString(array: string[]): string {
  if (array.length) {
    let resultString = ""
    array.forEach(function (keyword, i) {
      resultString += keyword
      if (i < array.length - 1) {
        resultString += ", "
      }
    })
    return resultString
  } else {
    return ""
  }
}

/**
 * Sorts a results array by the first element (result number)
 * @param resultsArray - Array of [number, any] tuples to sort
 * @param sortOrder - Sort order: "asc" or "desc"
 * @returns Sorted results array
 */
function sortResultsArray(
  resultsArray: Array<[number, any]>,
  sortOrder: string = "asc"
): Array<[number, any]> {
  // Convert the result number in each nested array to a padded string
  // (adds a leading zero where needed).
  // This is to ensure that numbers 1-9 always appear before 10.
  resultsArray.forEach((item) => {
    item[0] = numToPaddedString(item[0]) as any
  })
  // Sort the array.
  if (sortOrder === "desc") {
    // Sort descending.
    resultsArray.sort((a, b) => (b[0] as any) - (a[0] as any))
  } else {
    // Sort ascending.
    resultsArray.sort()
  }
  // Now convert the padded strings back into numbers to remove any leading zeros.
  resultsArray.forEach((item) => {
    item[0] = Number(item[0])
  })
  return resultsArray
}

export { arrayToString, sortResultsArray }
